function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from "./reset-password-form.scss";
import template from "./reset-password-form.html";
import { resetPassword } from "redesign/shared/helpers/reset-password";

export var ResetPasswordFormComponent = {
  template: template,
  styles: styles,
  bindings: {},
  controller: /*#__PURE__*/function () {ResetPasswordFormComponentController.$inject = ["$location", "$state", "$timeout", "$modelFactory", "NavigationStack", "AuthenticationNew"];
    function ResetPasswordFormComponentController($location, $state, $timeout, $modelFactory, NavigationStack, AuthenticationNew) {
      "ngInject";_classCallCheck(this, ResetPasswordFormComponentController);
      this.$location = $location;
      this.$state = $state;
      this.$timeout = $timeout;
      this.$modelFactory = $modelFactory;

      this.NavigationStack = NavigationStack;
      this.AuthenticationNew = AuthenticationNew;

      this.loading = false;
      this.isErrorsVisible = false;
      this.errorMessage = '';
      this.authModel = {};
    }_createClass(ResetPasswordFormComponentController, [{ key: "onSubmit", value: function onSubmit(

      e) {var _this = this;
        this.isLoading = true;
        resetPassword({
          email: this.authModel.email,
          csrfToken: 'E4Av762CqxuA0ecK3Pclh7frZOF2Ds9v' }).

        then(function (res) {
          console.warn('resetPassword success', res);
        }).
        then(function (err) {
          console.warn('resetPassword error', err);
        }).
        finally(function () {
          _this.isLoading = true;
        });
      } }]);return ResetPasswordFormComponentController;}() };